import { render, staticRenderFns } from "./IllustrationBannerSection.vue?vue&type=template&id=5250e88a"
import script from "./IllustrationBannerSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationBannerSection.vue?vue&type=style&index=0&id=5250e88a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports